const STORAGE_KEY = "helios.voice.deviceId:v1";

let cachedDeviceId: string | null = null;

/**
 * Stable per-browser device identifier sent with voice access-token
 * requests. Twilio uses it (via the token's `endpointId`) to dedupe
 * registrations, so re-registering from the same browser replaces the
 * previous endpoint instead of ringing it twice.
 */
export function getVoiceDeviceId(): string {
  if (cachedDeviceId) {
    return cachedDeviceId;
  }
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      cachedDeviceId = stored;
      return stored;
    }
    const generated = `web-${crypto.randomUUID()}`;
    localStorage.setItem(STORAGE_KEY, generated);
    cachedDeviceId = generated;
    return generated;
  } catch {
    // Incognito/private browsing or storage disabled — fall back to a
    // session-stable id so token requests still work.
    cachedDeviceId = `web-${crypto.randomUUID()}`;
    return cachedDeviceId;
  }
}
